var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.onGoingAndStarted)?_c('item-state',{attrs:{"waitingMode":_vm.waitingMode,"alarmStatus":_vm.alarmStatusLast}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }